/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page4_Replace_OtherInputs */



/**
* | output |
* | --- |
* | "When replacing heads during maintenance, contact Eisox support." |
*
* @param {Intervention_Plan_Pdf_Page4_Replace_OtherInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page4_replace_other = /** @type {((inputs?: Intervention_Plan_Pdf_Page4_Replace_OtherInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page4_Replace_OtherInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("When replacing heads during maintenance, contact Eisox support.")
	return /** @type {LocalizedString} */ ("En cas de remplacement de tetes th. lors de votre maintenance contactez le service support Eisox.")
});